<template>
  <div
    class="ms-auto w-md-auto mt-2"
    v-if="
      $store.state.page >= showFromPage && !$store.state.customer_link_reloaded
    "
  >
    A díjindikáció PDF letöltése vagy link generálása után jelen díjszámítás nem
    módosítható, újabb díjszámítást az Új díjszámítás indítása gombbal lehet
    indítani.
    <div
      class="ms-auto w-md-auto mt-2"
      v-if="!PdfRequested && $store.state.page >= showFromPage"
    >
      <button
        @click.prevent="generateClaimIdentifier('getajanlatpdf')"
        class="btn btn-red claim-identifier"
        :disabled="disablePdfButton"
      >
        Díjindikáció pdf létrehozása
      </button>
    </div>
    <div
      class="ms-auto w-md-auto mt-2"
      v-else-if="$store.state.ajanlat_href && $store.state.page >= showFromPage"
    >
      <a
        :href="$store.state.ajanlat_href"
        target="_blank"
        class="btn btn-red claim-identifier"
        >Díjindikáció letöltése pdf-ben</a
      >
    </div>
    <div
      class="ms-auto w-md-auto mt-2"
      v-else-if="
        $store.state.page >= showFromPage && !$store.state.ajanlat_href
      "
    >
      <button class="btn btn-red claim-identifier">
        Kérem várjon
      </button>
    </div>
    <div v-if="!requestPdfButtonValid" class="pdf-warning">
      Kerjük, fogadja el a kötelező nyilatkozatokat a pdf létrehozása előtt
    </div>
    <div v-else class="pdf-warning">
      A biztosítás "Megkötöm a biztosítást" gomb megnyomása után lesz érvényes
      szerződés
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: ["showFromPage", "requestPdfButtonValid", "ivalid"],
  methods: {
    generateClaimIdentifier(code) {
      this.$gtm.trackEvent({
        event: "generatepdf", // Event type [default = 'interaction'] (Optional)
        label: "generatepdf",
        category: "Calculator",
        action: "click",
        transaction_id: this.$store.state.product_code,
        noninteraction: false, // Optional
      });
      this.$store.commit("setClaimIdentifier", code);
      this.$store.dispatch("verifyPage");
      this.$store.commit("setNavigationBackButton", true);
      // this.$store.commit('setClaimIdentifier', '');
    },
  },
  computed: {
    ...mapFields([
      "merchant_id",
      "startDate",
      "statementSettings.privacyStatement",
      "statementSettings.privacyProtection",
      "statementSettings.biztositasi_feltetelek",
      "statementSettings.electronicCommunation",
      "statementSettings.marketingMails",
      "statementSettings.acceptTerms",
      "statementSettings.ekapcsolatStatement",
      "statementSettings.validMerchant",
      "statementSettings.validDatas",
      "statementSettings.contrctReasonStatement",
      "statementSettings.ptkStatement",
      "statementSettings.sanctionsStatement",
      "statementSettings.oroszorszag",
      "statementSettings.orosz_nyilatkozat",
      "statementSettings.insuranceTerms",
    ]),
    ClamIdentifie() {
      return this.$store.state.code;
    },
    PdfRequested() {
      return this.$store.state.pdfrequested;
    },
    isPdfButtonDisabled() {
      return !this.requestPdfButtonValid;
    },
    disablePdfButton() {
      if (this.merchant_id !== "colo213" && this.merchant_id !== "eurosales") {
        return !(
          (
            this.orosz_nyilatkozat &&
            // this.oroszorszag &&
            this.privacyStatement &&
            // this.biztositasi_feltetelek &&
            this.privacyProtection &&
            this.ptkStatement &&
            this.contrctReasonStatement &&
            this.insuranceTerms &&
            this.sanctionsStatement &&
            this.ekapcsolatStatement
          )
          //Ez csak akkor, ha megjelenik!
          // this.sanctionsStatement
        );
      } else {
        return !(
          this.orosz_nyilatkozat &&
          // this.oroszorszag &&
          this.ekapcsolatStatement &&
          this.privacyStatement &&
          // this.biztositasi_feltetelek &&
          this.privacyProtection &&
          this.ptkStatement &&
          this.insuranceTerms &&
          this.contrctReasonStatement
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$red: #e4002b;
.pdf-warning {
  color: $red;
  text-align: right;
}
</style>
